import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spam-message',
  templateUrl: './spam-message.component.html',
  styleUrls: ['./spam-message.component.css']
})
export class SpamMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
